// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3H8yo","addWidgetButton":"Header_addWidgetButton__WRO_k","dashboardTabs":"Header_dashboardTabs__1wXKF","active":"Header_active__2BzJC"};